import { CompSelectionProperty, QualityTierBreakdownData } from '../../types.ts';
import { getQualityTierPrice } from './getQualityTierPrice.ts';

export const getQualityTierBreakdownData = (
  properties: CompSelectionProperty[],
): QualityTierBreakdownData => {
  const propertiesByQualityTier: Record<
    number,
    { properties: CompSelectionProperty[]; priceBand?: string; medianGla?: string; countOfSales?: number }
  > = properties.reduce(
    (acc, p) => {
      if (!p.qualityTier) return acc;
      if (!acc[p.qualityTier]) {
        acc[p.qualityTier] = { properties: [] };
      }
      acc[p.qualityTier]!.properties.push(p);
      return acc;
    },
    {} as Record<number, { properties: CompSelectionProperty[] }>,
  );

  Object.entries(propertiesByQualityTier).forEach(([tier, props]) => {
    const sorted = props.properties
      .filter((p) => getQualityTierPrice(p) != null)
      .sort(
        (a, b) => getQualityTierPrice(a)!.toDollarLike() - getQualityTierPrice(b)!.toDollarLike(),
      );
    propertiesByQualityTier[Number(tier)]!.properties = sorted;

    if (sorted.length === 1) {
      propertiesByQualityTier[Number(tier)]!.priceBand = getQualityTierPrice(sorted[0]!)!.toString(true);
    } else if (sorted.length > 1) {
      propertiesByQualityTier[Number(tier)]!.priceBand = `${getQualityTierPrice(sorted[0]!)!.toString(true)} - ${getQualityTierPrice(sorted[sorted.length - 1]!)!.toString(true)}`;
    }

    const sortedPropertyGlas = sorted
      .filter((p) => !!p.gla)
      .map((p) => p.gla!)
      .sort((a, b) => a.toSqFt().unitAmount - b.toSqFt().unitAmount);
    propertiesByQualityTier[Number(tier)]!.medianGla =
      sortedPropertyGlas[Math.floor(sortedPropertyGlas.length / 2)]?.toString();

    propertiesByQualityTier[Number(tier)]!.countOfSales = sorted.length;
  });

  return propertiesByQualityTier;
};
